import React from 'react'

export const SectionThree = () => {
  return (
    <div>
          <div className="section-three">
              <div className="container-fulid mt-4 ">
              <div className="faq-heading">
                <h1 style={{ fontWeight: 600 }}>Your AI-Powered Support Assistant, Available 24/7</h1>
                </div>
                  
                <div className="text-sm px-5 flex justify-content-center">
                    <p style={{ color: "black", fontWeight:"100" }}>
                    Deliver instant, human-like responses across WhatsApp, Instagram, Email, and more—24x7, in 100+ languages. Automate <br /> 80%+ of customer queries with an AI chat bot while driving conversions and improving CSAT with every conversation.
                    </p>
                </div>
                  
                <div className="support-section">
                    <div className="support-grid">
                        <div className="support-card">
                        <div className="support-icon">
                            <img src="/assets/images/kwikengage/ai.png" alt="AI Support" />
                        </div>
                        <h4>AI-Powered Instant Support</h4>
                        <ul>
                            <li>24/7 real-time replies via AI chatbot</li>
                            <li>Supports 100+ languages</li>
                            <li>Consistent support for pre/post-sale flows</li>
                        </ul>
                        </div>

                        <div className="support-card">
                        <div className="support-icon">
                            <img src="/assets/images/kwikengage/arrow.png" alt="Automated Ops" />
                        </div>
                        <h4>Automated & Scalable Ops</h4>
                        <ul>
                            <li>80% query resolution via AI</li>
                            <li>&lt;10% agent handover</li>
                            <li>Lean support teams</li>
                        </ul>
                        </div>

                        <div className="support-card">
                        <div className="support-icon">
                            <img src="/assets/images/kwikengage/thumb.png" alt="Satisfaction" />
                        </div>
                        <h4>Higher Satisfaction</h4>
                        <ul>
                            <li>Achieve 90% CSAT</li>
                            <li>Personalized, context-rich support</li>
                            <li>Boost retention & conversions</li>
                        </ul>
                        </div>
                    </div>
                    </div>

      
      
            
               
            
            
          
              </div>
          </div>
    </div>
  )
}

